/**
 * AddVodSetSettingsCtrl controller
 */

import {
  REPORT_DISPLAY_MODE_TYPES, SET_PRICING_MONETIZATION_TYPES, SET_PRICING_MONETIZATION_TYPES_LABELS,
  SET_PRICING_PAYMENT_METHOD_TYPES, SET_PRICING_PAYMENT_METHOD_TYPES_LABELS,
  SET_PRICING_POLICY_TEXT_TYPES, SET_SETTINGS_TYPES
} from 'app/core/constants'

/**
 * AddVodSetSettingsCtrl controller
 *
 * @class AddVodSetSettingsCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:AddVodSetSettingsCtrl
 */
/* @ngInject */
export default function AddVodSetSettingsCtrl ($uibModal, $location, VODSetSetting, VODSetPricing, Subscription,
  pckg, subscription, vs, alertLiteSvc) {
  var vm = this

  /**
   * Default values for table state
   *
   * @type {Object}
   */
  const defaultTableState = {
    page: 0,
    count: 25,
    name: '',
    last: false
  }

  /**
   * VOD Set Setting
   *
   * @memberof mwApp/packages.controller:AddVodSetSettingsCtrl
   * @type {models.VODSetSetting}
   */
  vm.vs = vs

  /**
   * VOD Set Pricing
   *
   * @memberof mwApp/packages.controller:AddVodSetSettingsCtrl
   * @type {models.VODSetSetting}
   */
  vm.pricings = vs.pricings

  /**
   * Package/Network
   *
   * @memberof mwApp/packages.controller:AddVodSetSettingsCtrl
   * @type {models.Network}
   */
  vm.pckg = pckg

  // package id
  const networkId = pckg.id

  /**
   * Subscription
   *
   * @memberof mwApp/packages.controller:AddVodSetSettingsCtrl
   * @type {models.Subscription}
   */
  vm.subscription = subscription

  // subscription id
  const subscriptionId = subscription.id

  /**
   * Currency of subscription
   *
   * @memberof mwApp/packages.controller:AddVodSetSettingsCtrl
   * @type {models.Currency}
   */
  vm.currency = vm.subscription.currency

  /**
   * isNew flag
   *
   * @memberof mwApp/packages.controller:AddVodSetSettingsCtrl
   * @type {Boolean}
   */
  vm.isNew = vs._isNew()

  /**
   * isFound flag
   *
   * @memberof mwApp/packages.controller:AddVodSetSettingsCtrl
   * @type {boolean}
   */
  vm.isFound = !!vm.vs.pricings.length

  /**
   * VOD Set Type
   *
   * @memberof mwApp/packages.controller:AddVodSetSettingsCtrl
   * @type {Object}
   */
  vm.setSettingsTypes = SET_SETTINGS_TYPES

  /**
   * Display period types
   *
   * @memberof mwApp/packages.controller:AddVodSetSettingsCtrl
   * @type {Object}
   */
  vm.report_display_mode_types = REPORT_DISPLAY_MODE_TYPES

  /**
   * Vod Set Pricing payment method types
   *
   * @memberof mwApp/packages.controller:AddVodSetSettingsCtrl
   * @type {Object}
   */
  vm.set_pricing_payment_method_types = SET_PRICING_PAYMENT_METHOD_TYPES

  /**
   * Vod Set Pricing payment method labels
   *
   * @memberof mwApp/packages.controller:AddVodSetSettingsCtrl
   * @type {Object}
   */
  vm.set_pricing_payment_method_labels = SET_PRICING_PAYMENT_METHOD_TYPES_LABELS

  /**
   * Display Monetization types
   *
   * @memberof mwApp/packages.controller:AddVodSetSettingsCtrl
   * @type {Object}
   */
  vm.vod_set_pricing_monetization_types = SET_PRICING_MONETIZATION_TYPES

  /**
   * Display Monetization labels
   *
   * @memberof mwApp/packages.controller:AddVodSetSettingsCtrl
   * @type {Object}
   */
  vm.vod_set_pricing_monetization_labels = SET_PRICING_MONETIZATION_TYPES_LABELS

  /**
   * Display Policy types
   *
   * @memberof mwApp/packages.controller:AddVodSetSettingsCtrl
   * @type {Object}
   */
  vm.vod_set_pricing_policy_types = SET_PRICING_POLICY_TEXT_TYPES

  // load extra for vod set settings
  vm.tableState = angular.copy(defaultTableState)

  vm.vodSets = [{ id: vs.vodSetId }]
  if (vm.isNew) {
    Subscription.loadVODSets(Subscription.extraFor(subscription), vm.tableState)
      .then((result) => {
        vm.vodSets = result.content
        vm.tableState.last = result.last
      })
  }

  /**
   * Filter vod-sets, it seems that this works faster, then filter in ui-select-choices
   *
   * @memberof mwApp/shows.controller:AddVodSetSettingsCtrl
   * @param  {Object} $select
   */
  vm.$timer = 0
  vm.openCount = 0
  vm.refreshVODSets = function ($select = {}) {
    const search = $select.search || null

    vm.tableState.page = 0

    vm.openCount = $select.open ? vm.openCount + 1 : 0

    if (vm.openCount >= 1 && search) {
      vm.tableState.name = search
    }

    /*
      if (vm.openCount === 1) {
        $select.search = vm.tableState.name
      } */

    if ($select.open) {
      window.clearTimeout(vm.$timer)
      vm.$timer = window.setTimeout(() => {
        Subscription.loadVODSets(Subscription.extraFor(subscription), { ...vm.tableState })
          .then((result) => {
            vm.vodSets = result.content || []
            vm.tableState.last = result.last
          })
      }, 700)
    }
  }

  /**
   * Handler for scroll event of Available select list
   *
   * @memberof mwApp/packages.controller:AddVodSetSettingsCtrl
   * @param event
   */
  vm.$timerScroll = 0
  vm.vodSetsCallbackScroll = (event) => {
    const {
      page,
      last
    } = vm.tableState
    if (!last && event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6) {
      window.clearTimeout(vm.$timerScroll)
      vm.$timerScroll = window.setTimeout(() => {
        Subscription.loadVODSets(Subscription.extraFor(subscription), { ...vm.tableState, page: page + 1 })
          .then((result) => {
            vm.tableState.last = result.last
            vm.vodSets = vm.vodSets.concat(result.content)
            vm.tableState.page = result.number
          })
      }, 700)
    }
  }

  /**
   * Create or edit vod set settings
   *
   * @memberof mwApp/packages.controller:AddVodSetSettingsCtrl
   */
  vm.submit = function () {
    vm.setDisable()
    vs._save({ networkId, subscriptionId })
      .then(() => { $location.url(subscription._publicUrl) })
      .catch(err => {
        alertLiteSvc.alert(vs._errorHandling(err), 'danger', 7000)
      })
      .finally(() => vm.unsetDisable())
  }

  /**
   * Create/Update pricing
   *
   * @memberof mwApp/packages.controller:AddVodSetSettingsCtrl
   * @function
   * @param {models.VODSetPricing} pricing
   */
  vm.addPricing = vm.editPricing = function (pricing) {
    var isNew = !pricing
    var initialPricing = angular.copy(pricing) // initial state
    $uibModal.open({
      templateUrl: 'components/packages/views/addVodSetPricing.html',
      controller: 'AddVodSetPricingCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        vs: function () {
          return vm.vs
        },
        pricing: function () {
          return !isNew
            ? pricing
            : (
              new VODSetPricing()
            )
        },
        currency: function () {
          return subscription.currency
        }
        /* discounts: function () {
          return angular.copy(vm.discounts)
        } */
      }
    }).result
      .then(
        function close (pricing) {
          if (isNew) {
            vm.vs.pricings.push(pricing)
          }
        },
        function dismiss () {
          if (!isNew) {
            angular.copy(initialPricing, pricing) // restore pricing
          }
        })
  }

  /**
   * Delete vod set pricing
   *
   * @memberof mwApp/discounts.controller:AddVodSetSettingsCtrl
   * @param {Number} index
   */
  vm.deletePricing = function (index) {
    vm.vs.pricings.splice(index, 1)
  }

  vm.createVodSet = function () {
    $location.url(vm.pckg._publicUrl + '/contentSets/vod/new')
  }
}
